export const sessionQueryKeys = {
    user: ["getUser"],
} as const;
